import { TaskRelevance } from './task-relevance.enum';
export class Task {
  id: number;
  relevance: TaskRelevance;
  processingStatus: string;

  constructor(task: Task) {
    this.id = task.id;
    this.relevance = task.relevance;
    this.processingStatus = task.processingStatus;
  }
}
